export function dropIds<T>(source: Map<string, T>, ids: Iterable<string>): Map<string, T> {
  const next = new Map(source);

  let changed = false;
  for (const id of ids) {
    if (next.delete(id)) changed = true;
  }

  return changed ? next : source;
}
